import { createElement } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export const SvgIconBlank = (props: SvgIconProps) =>
  createElement(SvgIcon, {
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24',
    fill: 'none',
    ...props,
  });
export default SvgIconBlank;
